import { useEffect, useRef } from "react";

export default function ObservedSection({ onEnter, onLeave, children, className }) {
  const ref = useRef(null);
  const state = useRef(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if(entry.isIntersecting == state.current) return
        state.current = entry.isIntersecting
        if (entry.isIntersecting) {
          onEnter?.();
        } else {
          onLeave?.();
        }
      },
      { threshold: 0.1 } // fire when at least 10% is visible
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [onEnter, onLeave]);

  return <div ref={ref} className={className} style={{maxWidth: '100%'}}>{children}</div>;
}